/**
 * Bastard implementation of AMD for our own limited needs.
 */

class Amd {
  constructor() {}
  hooks(url, pc) {
    return new Promise(resolve => {
      window.define = async (deps, fn) => {
        const jquery = await import(/* webpackChunkName: "jquery" */ 'jquery');
        resolve(fn(jquery.default, pc));
      };
      const tag = document.createElement('script');
      tag.src = url;
      document.getElementsByTagName('head')[0].appendChild(tag);
    });
  }
}

export const amd = new Amd();
